import * as devisConf from '@/configuration/devisConf';

export default function genererCritereRechercheRapprochement() {
  return {
    tiersId: [],
    societeId: null,
    codesDossier: [],
    montantDifferentZero: true,
    aRapprocher: true,
    etat: [devisConf.ETAT_ENREGISTRE, devisConf.ETAT_FACTURE_PARTIELLEMENT, devisConf.ETAT_FACTURE],
    datesPremierAffichage: {
      dateDebut: null,
      dateFin: null,
    },
  };
}
